import { Outlet } from "@tanstack/react-router";

export function LearnLayout() {
	return <Outlet />;
}
